import axios from '../../../../shared/axios';

import * as actionTypes from '../constants/spoke';

import { AppDispatch } from '../../../../store';

import { DeleteSpokeAccountRequest, SaveSpokeAccountRequest, SpokeAccount } from '../../models';

const getSpokeAccountStart = () => {
  return {
    type: actionTypes.SPOKE_GET_SPOKE_ACCOUNT_START,
  };
};

const getSpokeAccountSuccess = (data: SpokeAccount) => {
  return {
    type: actionTypes.SPOKE_GET_SPOKE_ACCOUNT_SUCCESS,
    data,
  };
};

const getSpokeAccountFail = (error: any) => {
  return {
    type: actionTypes.SPOKE_GET_SPOKE_ACCOUNT_FAIL,
    error,
  };
};

export const getSpokeAccount = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<SpokeAccount>((resolve, reject) => {
      dispatch(getSpokeAccountStart());

      const url = `/spoke/get-spoke-account`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getSpokeAccountSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getSpokeAccountFail(err));
          reject(err);
        });
    });
  };
};

const saveSpokeAccountStart = () => {
  return {
    type: actionTypes.SPOKE_SAVE_SPOKE_ACCOUNT_START,
  };
};

const saveSpokeAccountSuccess = (data: boolean) => {
  return {
    type: actionTypes.SPOKE_SAVE_SPOKE_ACCOUNT_SUCCESS,
    data,
  };
};

const saveSpokeAccountFail = (error: any) => {
  return {
    type: actionTypes.SPOKE_SAVE_SPOKE_ACCOUNT_FAIL,
    error,
  };
};

export const saveSpokeAccount = (params: SaveSpokeAccountRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(saveSpokeAccountStart());

      const url = `/spoke/save-spoke-account`;

      axios
        .post(url, params)
        .then((response) => {
          dispatch(saveSpokeAccountSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveSpokeAccountFail(err));
          reject(err);
        });
    });
  };
};

const deleteSpokeAccountStart = () => {
  return {
    type: actionTypes.SPOKE_DELETE_SPOKE_ACCOUNT_START,
  };
};

const deleteSpokeAccountSuccess = (data: boolean) => {
  return {
    type: actionTypes.SPOKE_DELETE_SPOKE_ACCOUNT_SUCCESS,
    data,
  };
};

const deleteSpokeAccountFail = (error: any) => {
  return {
    type: actionTypes.SPOKE_DELETE_SPOKE_ACCOUNT_FAIL,
    error,
  };
};

export const deleteSpokeAccount = (params: DeleteSpokeAccountRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(deleteSpokeAccountStart());

      const url = `/spoke/delete-spoke-account`;

      axios
        .delete(url, { params })
        .then((response) => {
          dispatch(deleteSpokeAccountSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(deleteSpokeAccountFail(err));
          reject(err);
        });
    });
  };
};

const getWebhookUrlStart = () => {
  return {
    type: actionTypes.SPOKE_GET_WEBHOOK_URL_START,
  };
};

const getWebhookUrlSuccess = (data: string) => {
  return {
    type: actionTypes.SPOKE_GET_WEBHOOK_URL_SUCCESS,
    data,
  };
};

const getWebhookUrlFail = (error: any) => {
  return {
    type: actionTypes.SPOKE_GET_WEBHOOK_URL_FAIL,
    error,
  };
};

export const getWebhookUrl = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<string>((resolve, reject) => {
      dispatch(getWebhookUrlStart());

      const url = `/spoke/get-webhook-url`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getWebhookUrlSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getWebhookUrlFail(err));
          reject(err);
        });
    });
  };
};
